export default __webpack_public_path__ + "static/media/create-event-hint.c3f00af8.svg";